import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import gemapiImg from "../../images/gemapi_cover.jpg";
const GemapiHeroSection = () => {
  const path = useLocation();
  const [title, setTitle] = useState("GEMAPI");
  const [desc, setDesc] = useState(
    "Une mission pour nos rivières et nos territoires"
  );
  useEffect(() => {
    switch (path.search) {
      case "?ru-de-gally":
        setTitle("L'histoire de l'eau ");
        setDesc("");
        break;
      case "?nos-equipements":
        setTitle("Nos Equipements");
        setDesc(
          "AQUAVESC, acteur majeur de la gestion de l'eau à Versailles, est responsable d’un patrimoine hydraulique exceptionnel, hérité du XVIIe siècle. Aqueducs, réservoirs et ouvrages historiques : Le syndicat veille à préserver ces équipements, témoins du passé, pour qu’ils  continuent de nourrir l’avenir de l’eau potable, entre hier, aujourd’hui et demain."
        );
        break;

      case "?source":
        setTitle("De la source au robinet");
        setDesc("");
        break;

      default:
        break;
    }
  }, [path.search]);

  return (
    <div className="">
      <section
        className="p-10 text-center lg:p-32 bg-black/70 bg-blend-overlay "
        style={{
          backgroundImage: `url(${gemapiImg})`,
          backgroundSize: "cover",
        }}
      >
        <h1 className="text-2xl font-bold text-center text-white md:text-4xl lg:text-7xl">
          {title}
        </h1>

        <div className="flex justify-center mt-5">
          <p className="w-full text-white">{desc}</p>
        </div>
      </section>
    </div>
  );
};

export default GemapiHeroSection;
